import { Chip } from '@hopskipdrive/react-components';
import styled from 'styled-components';

import { colorPalette, colorTokens } from '../../../../shared/components/variables';

export const StatusChip = styled(Chip)`
  height: 1.6875rem;
  border-radius: 0.25rem;
  justify-content: flex-start;
  svg {
    width: 1rem;
    height: 1rem;
  }
  &.status-open {
    background-color: ${colorPalette.red975};
    color: ${colorPalette.neutral200};
    border: 1px solid ${colorTokens.error.outlineBorder};
  }
  &.status-resolved {
    background-color: ${colorPalette.green975};
    color: ${colorPalette.neutral200};
    border: 1px solid ${colorTokens.success.outlineBorder};
  }
`;
